import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";

import "../App.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-awesome-reveal";

import FotoBofedales from "../img/bofedales.jpg";
import FotoHumedales from "../img/humedales.jpg";
import FotoConvoca from "../img/informe-convoca.png";
import FotoComic from "../img/comic.jpg";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Agua e infraestructura natural en el Perú</title>
        <meta
          property="og:title"
          content="Agua e infraestructura natural en el Perú"
        />
        <meta
          name="description"
          content="Serie de reportajes realizados con el fin de generar un mayor debate entre la ciudadanía y los decisores políticos sobre la importancia y eficacia de la infraestructura natural para la gestión sostenible del agua."
        ></meta>
        <meta property="og:url" content={process.env.REACT_APP_URL} />
        <meta
            property="og:image"
            content="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/portada.jpg"
        />
      </Helmet>
      <header className="header">
        <Navbar url="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/" />
        <div className="main-title d-flex align-items-center flex-column text-center">
          <Fade triggerOnce="true" delay="100" duration="1000">
            <h1>Agua e infraestructura natural en el Perú</h1>
          </Fade>
          <Fade triggerOnce="true" delay="200" duration="1000">
            <p className="bajada mt-2 mt-md-3">
              Serie de reportajes realizados con el fin de generar un mayor
              debate entre la ciudadanía y los decisores políticos sobre la
              importancia y eficacia de la infraestructura natural para la
              gestión sostenible del agua. Los reportajes fueron producidos en
              alianza con la{" "}
              <a
                href="https://fundacionmohme.org/"
                target="_blank"
                rel="noreferrer"
              >
                Fundación Gustavo Mohme Llona
              </a>
              .
            </p>
          </Fade>
        </div>
      </header>
      <div className="bg-container">
        <Container className="container-content">
          <Row className="justify-content-center">
            <Col md={6} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-center justify-content-between text-center">
                  <div>
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${FotoConvoca})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Huaros: entre el cuidado sostenido del agua y la
                        migración a Lima
                      </h5>
                      <div className="author">
                        <small>Por: Jackeline Cárdenas Ipenza / Convoca</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <Button
                      variant="outline-primary"
                      href="https://www.convoca.pe/en/node/1715"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Leer informe
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={6} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-center justify-content-between text-center">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${FotoBofedales})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">Bofedales en emergencia</h5>
                      <div className="author">
                        <small>
                          Por: Nicol León con colaboración de Sonia Condori / La
                          República
                        </small>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      variant="outline-primary"
                      href="https://especiales.larepublica.pe/bofedales-en-emergencia/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Leer informe
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={6} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-center justify-content-between text-center">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${FotoComic})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Reportaje en formato comic: Guardianas del agua
                      </h5>
                      <div className="author">
                        <small>
                          Por: Mirelis Morales Tovar y Valeria Aguilar / El
                          Comercio
                        </small>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Link to="/guardianas-del-agua">
                      <Button variant="outline-primary">Leer informe</Button>
                    </Link>
                  </div>
                </div>
              </Fade>
            </Col>
            <Col md={6} xs={12}>
              <Fade triggerOnce="true">
                <div className="card-informe d-flex flex-column align-items-center justify-content-between text-center">
                  <div className="w-100">
                    <div
                      className="card-img"
                      style={{ backgroundImage: `url(${FotoHumedales})` }}
                    ></div>
                    <div className="p-2">
                      <h5 className="mt-1 mb-2">
                        Video: Humedales urbanos, una lucha por sobrevivir
                      </h5>
                      <div className="author">
                        <small>
                          Por: Lilian Massiel Rosas Rivera, Carmen Cobeñas
                          Chávez y Karol Salazar Navarro / Prensa Chalaca
                        </small>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      variant="outline-primary"
                      href="https://www.youtube.com/watch?v=dHH1XpE9CWU"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Leer informe
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default Home;
